import * as React from 'react';
import {DefaultButton, PanelType, PrimaryButton} from '@fluentui/react';
import { Panel } from '@fluentui/react';
import {useState, useContext, useEffect} from "react";
import {DatePicker, SpinButton, Stack} from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";
import {dbDate} from "../../Utilities/dbDate";
import {Dropdown, Toggle} from "@fluentui/react";
import { NumericMoneyFormat } from "../../Utilities/MoneyFormat";
import NetGrossPicker from "../../Components/NetGrossPicker";

function AddProjectAddon(props) {
    const [user] = useContext(AuthContext);
    const [netTotal, setNetTotal] = useState(0);
    const [grossTotal, setGrossTotal] = useState(0);
    const [vat, setVat] = useState(0);
    const [netCost, setNetCost] = useState(0);
    const [grossCost, setGrossCost] = useState(0);
    const [quantity, setQuantity] = useState(1);
    const [addon, setAddon] = useState(null);
    const [addons, setAddons] = useState([]);
    const [deadline, setDeadline] = useState(null);
    const [included, setIncluded] = useState(false);
    const [internal, setInternal] = useState(false);
    const [ownCost, setOwnCost] = useState(false);
    const [discount, setDiscount] = useState(0);

    const _submit = (e) => {
        e.preventDefault();
        const data = {net_total: netTotal, gross_total: grossTotal, vat: vat, deadline: dbDate(deadline), venture_addon_id: addon.key, quantity: quantity, internal: internal, own_cost: ownCost, net_cost: netCost, gross_cost: grossCost};
        fetch(`/api/project/${props.add}/addon`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    useEffect(() => {
        const abortController = new AbortController();
        if (props.add) {
            setNetTotal(0);
            setGrossTotal(0);
            setNetCost(null);
            setGrossCost(null);
            setQuantity(1);
            setAddon(null);
            setDeadline(null);
            setIncluded(false);
            setInternal(false);
            setOwnCost(false);
            async function fetchVentures() {
                await fetch(`/api/project/${props.add}/addon`, {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                        'Authorization': 'Bearer ' + user.token
                    }
                }).then(res => res.json())
                    .then(data => {
                        setAddons(data.map((item) => {
                            return {key: item.id, text: item.addon, net_price: item.net_price, vat: item.vat, gross_price: item.gross_price, net_cost: item.net_cost, gross_cost: item.gross_cost};
                        }))
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
            fetchVentures();
        }
        return () => abortController.abort();
    }, [props.add, user.token])

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddProjectAddon'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);

    useEffect(() => {
        let nTotal = quantity * (addon?.net_price ?? 0) * (1 -(discount / 100));
        let gTotal = quantity * (addon?.gross_price ?? 0) * (1 -(discount / 100));
        let nTotalCost = quantity * (addon?.net_cost ?? 0);
        let gTotalCost = quantity * (addon?.gross_cost ?? 0);
        setNetTotal(NumericMoneyFormat(nTotal));
        setGrossTotal(NumericMoneyFormat(gTotal));
        setNetCost(NumericMoneyFormat(nTotalCost));
        setGrossCost(NumericMoneyFormat(gTotalCost));
        setVat(addon?.vat ?? 0);
    }, [quantity, addon, discount]);

    useEffect(() => {
        if (included) {
            setDeadline(null);
        }
    }, [included]);

    useEffect(() => {
        if (internal) {
            setIncluded(true);
        }
    }, [internal]);


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            type={PanelType.medium}
            headerText="Dodaj Dodatek"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddProjectAddon'>
                <Dropdown
                    label="Dodatek"
                    selectedKey={addon ? addon.key : undefined}
                    onChange={(e, item) => setAddon(item)}
                    placeholder="Wybierz z listy"
                    options={addons}
                />
                <SpinButton
                    label={'Ilość:'}
                    labelPosition={'top'}
                    min={0}
                    max={1000000}
                    step={0.01}
                    incrementButtonAriaLabel={'Increase value by 1'}
                    decrementButtonAriaLabel={'Decrease value by 1'}
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.value || '')}
                />
                <h3>Cena Bazowa: {addon?.net_price ?? 0} Netto, {addon?.vat}% VAT, {addon?.gross_price ?? 0} Brutto</h3>
                <NetGrossPicker net={netTotal} setNet={setNetTotal} gross={grossTotal} setGross={setGrossTotal} vat={vat} setVat={setVat} prefix={'Cena Razem '}/>
                <SpinButton
                    label={'Rabat %:'}
                    labelPosition={'top'}
                    min={0}
                    max={100}
                    step={0.01}
                    incrementButtonAriaLabel={'Increase value by 1'}
                    decrementButtonAriaLabel={'Decrease value by 1'}
                    value={discount}
                    onChange={(e) => setDiscount(e.target.value || '')}
                />
                <Toggle checked={included} label="Zawarty w umowie" onText="Tak" offText="Nie" onChange={(e, checked) => setIncluded(checked)} />
                <DatePicker
                    disabled={included}
                    label="Termin Płatności"
                    isRequired={true}
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={deadline}
                    onSelectDate={(e) => setDeadline(e || '')}
                />
                <Toggle checked={internal} label="Wewnętrzny (płaci firma)" onText="Tak" offText="Nie" onChange={(e, checked) => setInternal(checked)} />
                <Toggle checked={ownCost} label="Koszt Indywidualny" onText="Tak" offText="Nie" onChange={(e, checked) => setOwnCost(checked)} />
                <NetGrossPicker net={netCost} setNet={setNetCost} gross={grossCost} setGross={setGrossCost} vat={vat} setVat={setVat} hideVat={true} prefix={'Koszt [szt] '}/>
            </form>
        </Panel>
    )
}

export default AddProjectAddon;